import React from 'react';
import urls, { codeUrl } from '@/constants/urls';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import DeleteActionMenu from '@/components/ribbon-actions/DeleteActionMenu';
import CreateAction from '@/components/ribbon-actions/CreateAction';
import Events from '../hooks/events';
import Selectors from '../hooks/selectors';

const RequestsActions = ({ category }) => {
  const {
    allowCreate, allowDelete, allowRefresh, code, disableDelete, readStatus,
  } = Selectors.useRequestsActions({ category });
  const refresh = Events.useRefreshRequests(category);
  const showDelete = Events.useShowDeleteRequests(category);

  return (
    <>
      {allowCreate && (<CreateAction url={codeUrl(urls.REQUEST, code, '#')} />)}
      {allowRefresh && (<RefreshActionMenu onClick={() => refresh({ page: 1 })} readStatus={readStatus} />)}
      {allowDelete && (<DeleteActionMenu onClick={showDelete} disabled={disableDelete} />)}
    </>
  );
};

export default RequestsActions;
